import LinkToDocusaurus from '../LinkToDocusaurus'
import { bugHuntingHistory } from '../../docs-routes'

const LinkToBugHuntingHistoryDoc = () =>
  <LinkToDocusaurus path={bugHuntingHistory}>
    Learn more about Bug Hunting History
  </LinkToDocusaurus>

export default LinkToBugHuntingHistoryDoc
